import React, { useState } from "react";
import {
  Box,
  TextField,
  Button,
  Autocomplete,
  IconButton,
  Snackbar,
  Alert,
  Typography,
  MenuItem,
} from "@mui/material";
import { Add, Delete, Upload } from "@mui/icons-material";
import { getDecryptedAccessToken, getDecryptedData } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";

const muscleOptions = [
  "Glutes", "Hip Flexors", "Quads", "Core", "Abs", "Hamstrings", "Inner Thighs",
  "Middle Back", "Lower Back", "Ankles", "Calves", "Shoulders", "Arms", "Chest",
  "Obliques", "Outer Thighs", "Back", "Upper Back", "Biceps", "Triceps", "Hips",
  "Neck", "Wrists", "Lats", "Trapezius"
];

const equipmentOptions = [
  "No Equipment", "Dumbbells", "Resistance Band", "Medicine Ball", "Jump Rope",
  "Soft Ball", "Bench", "Kettlebell", "Box", "Step"
];

const unitOptions = ["Set", "Rep", "Minute", "Second", "Kg", "Lb", "Meter", "Yard"];

const CreateExercises = () => {
  const [formData, setFormData] = useState({
    exercise_name: "",
    primary_muscles: [],
    secondary_muscles: [],
    equipment: [],
    instructions: [""],
    exercise_benefits: [""],
    sets_reps: [],
    gif_url: "",
    proper_form_breathing: "test",
    // gif_file: null,
  });
const accessToken =getDecryptedAccessToken()
const LoginUserDetail = getDecryptedData()
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });

  const handleChange = (field, value) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleDynamicChange = (field, index, value) => {
    const updatedList = [...formData[field]];
    updatedList[index] = value;
    setFormData({ ...formData, [field]: updatedList });
  };

  const handleAddField = (field) => {
    setFormData({ ...formData, [field]: [...formData[field], ""] });
  };

  const handleRemoveField = (field, index) => {
    const updatedList = formData[field].filter((_, i) => i !== index);
    setFormData({ ...formData, [field]: updatedList });
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => setFormData({ ...formData, gif_file: reader.result, gif_url: "" });
    }
  };

  const handleAddSetUnit = () => {
    setFormData({
      ...formData,
      sets_reps: [...formData.sets_reps, { unit: "", value: "" }],
    });
  };

  const handleSetUnitChange = (index, key, value) => {
    const updatedSetsUnits = [...formData.sets_reps];
    updatedSetsUnits[index][key] = value;
    setFormData({ ...formData, sets_reps: updatedSetsUnits });
  };

  const handleRemoveSetUnit = (index) => {
    const updatedSetsUnits = formData.sets_reps.filter((_, i) => i !== index);
    setFormData({ ...formData, sets_reps: updatedSetsUnits });
  };
  const handleSubmit = async () => {
    setLoading(true);
    try {
      const payload = {
        ...formData,
        gif_url: formData.gif_file ? formData.gif_file : formData.gif_url,
        sets: formData.sets_reps.map((item) => item.value), // Fix: Removed JSON.stringify
        units: formData.sets_reps.map((item) => item.unit),
        created_by:LoginUserDetail.id
      };

      const response = await ApiServices.post("/apis/default/api/exercises", payload, {

          // "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        
      });

      if (response.status === 200 || response.status === 201) {
        setSnackbar({ open: true, message: "Exercise saved successfully!", severity: "success" });
        setFormData({
          exercise_name: "",
          primary_muscles: [],
          secondary_muscles: [],
          equipment: [],
          instructions: [""],
          exercise_benefits: [""],
          sets_reps: [],
          gif_url: "",
          gif_file: null,
        });
      } else {
        setSnackbar({ open: true, message: "Failed to save exercise!", severity: "error" });
      }
    } catch (error) {
      setSnackbar({
        open: true,
        message: error.response?.data?.message || "Error connecting to server!",
        severity: "error",
      });
    }
    setLoading(false);
};

  
  
  return (
    <Box sx={{ maxWidth: 600, mx: "auto", p: 3, borderRadius: 2, boxShadow: 3, bgcolor: "#fff" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>Create Exercise</Typography>

      <TextField
        label="Exercise Name"
        fullWidth
        value={formData.exercise_name}
        onChange={(e) => handleChange("exercise_name", e.target.value)}
        sx={{ mb: 2 }}
      />

      <Autocomplete
        multiple
        freeSolo
        options={muscleOptions}
        value={formData.primary_muscles}
        onChange={(e, newValue) => handleChange("primary_muscles", newValue)}
        renderInput={(params) => <TextField {...params} label="Primary Muscles" />}
        sx={{ mb: 2 }}
      />

      <Autocomplete
        multiple
        freeSolo
        options={muscleOptions}
        value={formData.secondary_muscles}
        onChange={(e, newValue) => handleChange("secondary_muscles", newValue)}
        renderInput={(params) => <TextField {...params} label="Secondary Muscles" />}
        sx={{ mb: 2 }}
      />

      <Autocomplete
        multiple
        freeSolo
        options={equipmentOptions}
        value={formData.equipment}
        onChange={(e, newValue) => handleChange("equipment", newValue)}
        renderInput={(params) => <TextField {...params} label="Equipment" />}
        sx={{ mb: 2 }}
      />

      <Box sx={{ mb: 2 }}>
        <Typography>Sets & Units</Typography>
        {formData.sets_reps.map((item, index) => (
          <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <TextField
              select
              value={item.unit}
              onChange={(e) => handleSetUnitChange(index, "unit", e.target.value)}
              sx={{ width: 120 }}
            >
              {unitOptions.map((unit) => (
                <MenuItem key={unit} value={unit}>{unit}</MenuItem>
              ))}
            </TextField>
            <TextField
              type="number"
              value={item.value}
              onChange={(e) => handleSetUnitChange(index, "value", e.target.value)}
              sx={{ flex: 1 }}
            />
            <IconButton onClick={() => handleRemoveSetUnit(index)}><Delete /></IconButton>
          </Box>
        ))}
        <Button startIcon={<Add />} onClick={handleAddSetUnit}>Add More</Button>
      </Box>

      {["instructions", "exercise_benefits"].map((field) => (
        <Box key={field} sx={{ mb: 2 }}>
          <Typography>{field.replace("_", " ")}</Typography>
          {formData[field].map((item, index) => (
            <Box key={index} sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <TextField
                fullWidth
                value={item}
                onChange={(e) => handleDynamicChange(field, index, e.target.value)}
              />
              <IconButton onClick={() => handleRemoveField(field, index)}><Delete /></IconButton>
            </Box>
          ))}
          <Button startIcon={<Add />} onClick={() => handleAddField(field)}>Add More</Button>
        </Box>
      ))}

      <Box sx={{ mb: 2 }}>
        <Typography>GIF URL / Upload</Typography>
        <TextField
          fullWidth
          value={formData.gif_url}
          onChange={(e) => handleChange("gif_url", e.target.value)}
          sx={{ mb: 1 }}
        />
        <Button component="label" variant="contained" startIcon={<Upload />}>
          Upload GIF
          <input type="file" hidden accept="image/gif" onChange={handleFileUpload} />
        </Button>
      </Box>

      <Button variant="contained" fullWidth disabled={loading} onClick={handleSubmit}>
        {loading ? "Saving..." : "Submit"}
      </Button>

      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
};

export default CreateExercises;
